export default {
  nav__site: "Mặt bằng",
  nav__store: "Cửa hàng",
  nav__market: "Thị trường",
  nav__map: "Bản đồ",
  nav__support: "Trợ giúp",
  nav__copy_url: "Copy link",
  nav__off_two_factor: "Tắt bảo mật 2 lớp",
  nav__on_two_factor: "Mở bảo mật 2 lớp",
  nav__log_out: "Đăng xuất",
  nav__select_a_language: "Chọn ngôn ngữ",
  nav__notification: "Thông báo",

  action__apply: "Áp dụng",
  action__close: "Đóng",
  action__default: "Về mặc định",
  action__cancel: "Huỷ bỏ",
  action__go_back: "Quay lại",
  action__continue: "Tiếp theo",
  action__edit: "Chỉnh sửa",
  action__save_and_preview: "Lưu và xem",
  action__create_new: "Tạo mới",
  action__add_owner: "Thêm chủ nhà có sẵn",
  action__add_update: "Thêm cập nhật",
  action__other_feature: "Tính năng khác",
  action__traffic: "Traffic",
  action__compare: "So sánh",
  action__hide: "Ẩn",
  action__convert_to_store: "Chuyển thành cửa hàng",
  action__save: "Lưu",
  action__save_and_continue: "Lưu & tiếp tục chỉnh sửa",
  action__save_and_calculation: "Lưu và tính toán",
  action__post: "Đăng",
  action__posting: "Đang đăng",
  action__create_contract: "Tạo hợp đồng",
  action__show: "Hiển thị",
  action__add: "Thêm",
  action__yes: "Đúng",
  action__no: "Không",
  action__remove: "Gỡ bỏ",
  action__delete: "Xoá",
  action__done: "Xong",
  action_saving: "Đang lưu",
  action__confirm: "Xác nhận",
  action_view__site_detail: "Xem chi tiết mặt bằng",

  home__site_listing: "Quản lý mặt bằng",
  home__my_site: "Mặt bằng tôi đang xử lý",
  home__store_listing: "Quản lý cửa hàng",
  home__market_info: "Thông tin thị trường",
  home__site_planning_zone: "Bản đồ quy hoạch",
  home__old_map: "Bản đồ cũ",
  home__change_password: "Đổi mật khẩu",
  home__settings: "Cài đặt",

  site_listing__site: "Mặt bằng",
  site_listing__all: "Tất cả",
  site_listing__status: "Trạng thái",
  site_listing__search_name_placeholder: "Tên mặt bằng, địa chỉ...",
  site_listing__city: "Tỉnh, thành phố",
  site_listing__assignee: "Người chịu trách nhiệm",
  site_listing__select_column_to_display: "Chọn cột để hiển thị",
  site_listing__create_new_site: "Tạo mặt bằng mới",
  site_listing__site_name: "Tên mặt bằng",
  site_listing__address: "Địa chỉ",
  site_listing__created_by: "Người tạo",
  site_listing__site_owner_reply_due_date: "Ngày hết hạn trả lời chủ nhà",
  site_listing__created_on: "Ngày tạo",
  site_listing__reverse_reason: "Lý do reverse",
  site_listing__filter_column_table_label: "Lọc hiển thị thông tin",
  site_listing__filter_show_all: "Hiển thị tất cả",
  site_listing__reverse_placeholder: "Nhập lý do",

  modal_create_site__title: "Thông tin mặt bằng mới",
  modal_create_site__store_type: "Mô hình hoạt động",
  modal_create_site__store_format: "Format cửa hàng",

  site_detail__assignment: "Người chịu trách nhiệm",
  site_detail__follower: "Người theo dõi",
  site_detail__processing: "Quy trình xử lý",
  site_detail__tab_summary: "Tóm tắt",
  site_detail__tab_general: "Thông tin chung",
  site_detail__tab_photo: "Hình ảnh",
  site_detail__tab_legal_document: "Pháp lý & Giấy tờ khác",
  site_detail__tab_rental_information: "Thông tin thuê",
  site_detail__tab_financial_projection: "Dự báo tài chính",
  site_detail__tab_comment: "Nhận xét",
  site_detail__tab_activity: "Hoạt động",
  site_detail__tab_changelog: "Changelog",
  site_detail__tab_external_dashboard: "External dashboard",
  site_detail__tab_contract: "Hợp đồng",

  site_summary_tab__site_map: "Bản đồ mặt bằng",
  site_summary_tab__pricing: "Chi phí",
  site_summary_tab__initial_lease_rate: "Tiền thuê mỗi tháng",
  site_summary_tab__calculation_method: "Cách tính",
  site_summary_tab__lease_term_year: "Số năm hợp đồng",
  site_summary_tab__increase_rate_year_period: "Chu kỳ tăng giá",
  site_summary_tab__estimate_cannibalization: "Ước tính cannibalization",
  site_summary_tab__area_and_size: "Diện tích & kích thước",
  site_summary_tab__site_width: "Chiều rộng",
  site_summary_tab__site_length: "Chiều dài",
  site_summary_tab__total_area: "Tổng diện tích",
  site_summary_tab__usable_area: "Diện tích sử dụng",
  site_summary_tab__parking: "Bãi xe",
  site_summary_tab__primary_parking: "Bãi xe chính",
  site_summary_tab__secondary_parking: "Bãi xe phụ",
  site_summary_tab__motorbike_parking_capacity: "Số xe máy",
  site_summary_tab__parking_unit: "chiếc",
  site_summary_tab__site: "Mặt bằng",
  site_summary_tab__site_description: "Mô tả thêm về mặt bằng",
  site_summary_tab__primary_site_surrounding_area:
    "Khu vự quanh mặt bằng (chính)",
  site_summary_tab__secondary_site_surrounding_area:
    "Khu vự quanh mặt bằng (phụ)",
  site_summary_tab__visibility: "Khả năng nhìn thấy",
  site_summary_tab__accessibility: "Khả năng tiếp cận",
  site_summary_tab__map_error:
    "Không hiện được bản đồ vì chưa có latitude, longitude",
  site_summary_tab__prediction: "Dự đoán",
  site_summary_tab__calculating: "Đang tính toán",
  site_summary_tab__site_comparison: "So sánh mặt bằng",
  site_summary_tab__investment_cost_and_break_even:
    "Chi phí đầu tư & Thời gian hoà vốn",

  site_information_tab__confirm_auto_geo:
    "Dữ liệu lat, lng lấy tự động có thể bị sai, vui lòng kiểm tra lại trên bản đồ và điều chỉnh nếu cần. Bạn có muốn tiếp tục?",
  site_information_tab__building: "Tòa nhà",
  site_information_tab__auto_lat_lng: "Lấy lat long tự động",
  site_information_tab__show_map: "Hiện bản đồ",
  site_information_tab__hide_map: "Ẩn bản đồ",
  site_information_tab__characteristic: "Đặc điểm mặt bằng",

  site_photo_tab__delete_photo: "Bạn có chắc sẽ xóa hình này?",
  site_photo_tab__insert_photo: "Đính kèm file",
  site_photo_tab__select_file: "Chọn file nào...",
  site_photo_tab__photo_guide_line: "Hướng dẫn chụp ảnh",

  site_legal_document__download_template: "Tải template",

  site_rental_information__time: "Thời gian",
  site_rental_information__other: "Thông tin thuê khác",
  site_rental_information__calculator: "Bảng tính",
  site_rental_information__select_calculator: "Chọn cách tính giá tiền thuê",
  site_rental_information__detail_calculator: "Chi tiết bảng tính",
  site_rental_information__phone_number: "Số điện thoại",
  site_rental_information__contact_placeholder: "Gõ tên, họ hoặc số điện thoại",

  site_final_projection__area_target_population: "Tổng dân số có thể target",
  site_final_projection__estimate_ticket_monthly:
    "Ước tính số ticket mỗi tháng",
  site_final_projection__average_ticket_value: "Ticket size trung bình",
  site_final_projection__estimate_revenue_monthly:
    "Ước tính doanh thu mỗi tháng",
  site_final_projection__estimate_ebitda_monthly: "Ước tính EBITDA mỗi tháng",
  site_final_projection__trade_area_analysis: "Dựa vào Trade Area Analysis",
  site_final_projection__store_sister: "Dựa vào Store Sister",
  site_final_projection__select_store_sister: "Chọn store sister",
  site_final_projection__select_store_sister_placeholder: "Chọn một cửa hàng",
  site_final_projection__operation_cost: "Các chi phí vận hành",

  site_comment__filter_comment_by_status: "Filter nhận xét theo trạng thái",
  site_comment__comment_loading: "Đang tải comment...",
  site_comment__no_comment: "Không có nhận xét nào.",
  site_comment__loading: "Đang tải...",
  site_comment__loadmore: "Tải thêm",
  site_comment__comment_placeholder: "Viết nhận xét của bạn vào đây...",
  site_comment__estimate_site_revenue: "Ước tính doanh thu của mặt bằng",

  site_activity__activity: "Hoạt động",
  site_activity__start: "Bắt đầu",
  site_activity__end: "Kết thúc",
  site_activity__note: "Ghi chú",

  site_changlog__user: "Người sử dụng",

  store_listing__id: "ID",
  store_listing__city: "Thành phố",
  store_listing__store: "Cửa hàng",
  store_listing__contract_from: "HĐ từ",
  store_listing__contract_to: "HĐ đến",
  store_listing__active_month: "Tháng hoạt động",
  store_listing__search_name_placeholder: "Tên cửa hàng",
  store_listing__store_name: "Tên cửa hàng",
  store_listing__address: "Địa chỉ",
  store_listing__store_id: "Mã cửa hàng",
  store_listing__open_date: "Ngày khai trương",
  site_listing__deposit: "Đặt cọc",
  site_listing__initial_lease_rate: "Đầu tư ban đầu",
  site_listing__payment_cycle: "Chu kỳ thanh toán",
  store_listing__contract_status: "Trạng thái hợp đồng",
  contract__active: "Đang hoạt động",
  contract__renew: "Gia hạn hợp đồng",
  contract_tax: "Thuế",

  store_detail__store_summary: "Tóm tắt",
  store_detail__store_information: "Thông tin cửa hàng",
  store_detail__store_location: "Vị trí cửa hàng",
  store_detail__store_photo: "Hình ảnh",
  store_detail__store_legal: "Thông tin pháp lý",
  store_detail__contact: "Liên hệ",
  store_detail__update: "Cập nhật",

  site_cannibalization_modal__title: "Dự đoán Cannibalization Rate",
  site_cannibalization_modal__cannibalization_rate: "Cannibalization Rate",
  site_cannibalization_modal__cannibalization_rate_description:
    "là % doanh thu ước tính của các cửa hàng xung quanh sẽ bị mất nếu mặt bằng này mở ra (bán kính 2km)",
  site_cannibalization_modal__calculating: "Đang tính toán... Chờ xíu nha...",
  site_cannibalization_modal__distance: "Khoảng cách",
  site_cannibalization_modal__revenue_lost:
    "Doanh thu sẽ mất vì Cannibalization",
  site_cannibalization_modal__vnd_per_month: "VND / tháng",

  site_calculate_modal__title: "Tính tiền thuê mặt bằng (cả mặt bằng)",
  site_calculate_modal__years: "Số năm",
  site_calculate_modal__years_placeholder: "Số năm thuê",

  site_contact_modal__last_name: "Họ",
  site_contact_modal__middle_name: "Tên lót",
  site_contact_modal__first_name: "Tên",
  site_contact_modal__primary_phone: "Số điện thoại chính",
  site_contact_modal__secondary_phone: "Số điện thoại phụ",
  site_contact_modal__email: "Email",
  site_contact_modal__home_address: "Địa chỉ nhà",
  site_contact_modal__work_address: "Địa chỉ nơi làm việc",
  site_contact_modal__note: "Ghi chú về chủ nhà",
  site_contact_modal__customer_type: "Khách là",
  site_contact_modal__select_an_option: "-- Chọn một giá trị --",
  site_contact_modal_is_host: "Đây là chủ nhà",
  site_contact_modal_relationship_host: "Quan hệ với chủ nhà",
  site_contact_modal_host: "Chủ nhà",
  site_contact_modal_phone_number: "Điện thoại",

  city_picker__city: "Thành phố (*)",
  city_picker__district: "Quận / Huyện (*)",
  city_picker__ward: "Phường / Xã (*)",
  site_activity_modal__title: "Hoạt động của mặt bằng",
  site_activity_modal__type_activity: "Loại hoạt động",
  site_activity_modal__from: "Từ ngày",
  site_activity_modal__to: "Đến ngày",
  site_activity_modal__note: "Ghi chú",

  site_contract_modal__title: "Tạo hợp đồng",
  site_contract_modal__edit: "Chỉnh sửa hợp đồng",
  site_contract_modal__view: "Hợp đồng",
  site_contract_modal__name: "Tên hợp đồng",
  site_contract_modal__type: "Loại hợp đồng",
  site_tax__type: "Loại thuế",
  site_contract_modal__date: "Ngày ký HĐ",
  site_contract_modal__start: "Thời hạn HĐ từ ngày",
  site_contract_modal__expire: "Thời hạn HĐ đến ngày",
  site_contract_modal__rental_from: "Thời gian thuê từ ngày",
  site_contract_modal__rental_to: "Thời gian thuê đến ngày",
  site_contract_modal__month_expire: "Thời hạn hợp đồng còn lại",
  site_contract_modal__pricing: "Giá thuê theo HĐ (sau thuế)",
  site_contract_modal__payment_term: "Điều khoản thanh toán",
  site_contract_modal__done_contract: "Chốt HĐ",
  site_contract_modal__edit_contract: "Chỉnh sửa HĐ",
  site_contract_modal__view_contract: "Xem HĐ",
  site_contract_modal__delete_contract: "Xoá HĐ",
  site_contract_modal__contract_info: "Thông tin hợp đồng",
  site_contract_modal__mark_as_rental_fee: "Dùng để tính tiền thuê",
  site_contract_modal__contract_done: "Hợp đồng đã chốt",
  site_contract_modal__remove_mark_as_rental_fee:
    "Bỏ đánh dấu hợp đồng tính tiền thuê",
  contract__payment_cycle: "Chu kỳ thanh toán",
  site_contract_modal__contract_number: "Số hợp đồng",
  site_contract_modal__rental_purpose: "Mục đích thuê",
  site_contract_modal__host_id: "Mã số thuế người cho thuê",
  site_contract_modal__host_name: "Tên người cho thuê",
  site_contract_modal__address: "Địa chỉ",
  site_contract_modal__type_of_rent_calculation: "Cách thức tính tiền thuê",
  site_contract_modal__period_type: "Loại chu kỳ thanh toán",
  site_contract_modal__rent_time: "Thời hạn thuê (tháng)",

  map__location: "Vị trí",
  map__getting_location: "Đang lấy vị trí",
  map__search_placeholder: "Nhập tên đường, địa điểm để tìm kiếm...",
  map__draw_potential_area: "Vẽ khu vực tiềm năng",
  map__radius_mode: "Hiển thị nhu cầu F&B và Ecommerce theo bán kính (Km)",
  map__radius_description: "Chọn vị trí trên bản đồ để hiển thị thông tin",
  map__show_potential_area: "Hiển thị khu vực tiềm năng",
  map__planning_zone_list: "Danh sách planning zone trong khu vực",
  map__type: "Loại bản đồ",
  map__people_unit: "người",
  map__population: "Dân số khu vực",
  map__population_description: "Dữ liệu từ tổng cục thống kê (2019)",
  map__show_area: "Hiển thị ranh giới",
  map__show_density_population: "Hiển thị mật độ dân số",
  map__show_by_ward: "Hiển thị theo Phường / Xã",
  map__show_by_district: "Hiển thị theo Quận / Huyện",
  map__age: "Độ tuổi",
  map__unit_vnd: "đồng",
  map__retail_demand: "Nhu cầu bán lẻ",
  map__avg_revenue: "Doanh thu trung bình ước tính trong 3 tháng",
  map__show_on_map: "Hiển thị trên bản đồ",
  map__unit_deal: "giao dịch",
  map__fb_demand: "Nhu cầu F&B",
  map__deal_from: "Giao dịch từ 11/2021 đến hết 02/2022",
  map__fb_demand_type: "Nhu cầu F&B tại quán",
  map__fb_demand_type_delivery: "Nhu cầu F&B giao tận nơi",
  map__no_data_yet: "Chưa có dữ liệu",
  map__ecommerce_demand: "Nhu cầu ecommerce",
  map__hide_all: "Ẩn toàn bộ",

  settings__title: "Cài đặt",
  settings__zone_management: "Quản lý vùng",
  settings__user_management: "Quản lý người dùng",
  settings__status_management: "Quản lý trạng thái",
  settings__zone_configure: "Cấu hình vùng",
  settings__user: "Người dùng",
  settings__custom_field: "Custom Field",

  zone_element__select_zone: "Chọn vùng...",
  zone_element__setting_zone: "Thiết lập vùng",
  zone_element__assign_user: "Phân quyền user vào vùng",
  zone_element__edit_zone: "Chỉnh sửa vùng",
  zone_element__select_zone_element: "Chọn thành phần của vùng",
  zone_element__setting_user: "Thiết lập user",
  zone_element__assign_user_to_zone: "Thêm user vào vùng quản lý",
  zone_element__create_new: "Tạo vùng mới",
  zone_element__name: "Tên",
  zone_element__name_placeholder: "Nhập tên vào đây...",
  zone_element__zone_level: "Cấp độ vùng",
  zone_element__select_level: "Chọn cấp độ...",
  zone_element__city: "Thành phố",
  zone_element__district: "Quận",
  zone_element__ward: "Phường",

  setting_user__search_placeholder: "Gõ tên hoặc username hoặc email...",
  setting_user__search: "Tìm kiếm",
  setting_user__searching: "Đang tìm...",
  setting_user__create_user: "Tạo người dùng",
  setting_user__import_user: "Import người dùng",
  setting_user__user_roles: "Vai trò",
  setting_user__zone: "Vùng",
  setting_user__active: "Kích hoạt",
  setting_user__brand_management: "Quản lý brand",
  setting_user__reset_password: "Đặt lại mật khẩu",
  setting_user__password_is: "Mật khẩu của người dùng này là",
  setting_user__import_title: "Import danh sách user",
  setting_user__download_template: "Tải template mẫu",
  setting_user__role_assign_user: "Các role bạn có thể gán cho user",
  setting_user__role_description:
    "Khi soạn file template, mỗi user có thể có nhiều role, các role được ngăn cách bằng dấu phẩy",
  setting_user__zone_assign_user: "Các zone bạn có thể gán cho user",
  setting_user__zone_description:
    "Khi soạn file template, mỗi user có thể có nhiều zone, các zone được ngăn cách bằng dấu phẩy",
  setting_user__select_file_import: "Chọn file để import",
  setting_user__upload_create_user: "Upload và tạo user",

  setting_status__guide_create: "• Tạo mới: Bấm SHIFT và CLICK vào màn hình",
  setting_status__guide_edit:
    "• Chỉnh sửa: chọn Trạng thái cần chỉnh sửa, sau đó bấm nút chỉnh sửa",
  setting_status__guide_link:
    "• Tạo liên kêt: Bấm SHIFT và kéo từ Trạng thái đầu đến Trạng thái cần liên kết",
  setting_status__create_new: "Tạo Trạng thái",
  setting_status__edit: "Chỉnh sửa Trạng thái",
  setting_status__name: "Tên status",
  setting_status__type: "Loại status",
  setting_status__order: "Thứ tự status",
  setting_status__role_can_update: "Role được chuyển trạng thái",
  setting_status__role_default_assignment: "Role mặc định để gán assignment",
  setting_status__show_on_progress_bar: "Hiển thị trên progress bar",
  setting_status__site_status_default: "Site status mặc định",
  setting_status__store_status_default: "Store status mặc định",
  setting_status__site_can_edit: "Site có thể chỉnh sửa",

  custom_tab__title: "Danh sách Tab",
  custom_tab__title_placeholder: "Tên Tab...",

  custom_tab_detail__title: "Danh sách Group",

  modal_create_tab__create_tab: "Tạo Tab",
  modal_create_tab__edit_tab: "Chỉnh sửa Tab",

  modal_create_group__create_group: "Tạo Group",
  modal_create_group__edit_group: "Chỉnh sửa Group",

  modal_create_field__create_field: "Tạo Field",
  modal_create_field__edit_field: "Chỉnh sửa Field",
  from_date: "Từ ngày",
  to_date: "Đến ngày",
  rental_fee: "Giá thuê cố định",
  rental_fee_percent: "Phần trăm doanh thu tính tiền thuê",
  rental_fee_with_tax: "Giá thuê cố định sau thuế",
  current_rental_fee: "Giá thuê hiện tại (trước thuế)",
  current_rental_fee_with_tax: "Giá thuê hiện tại (sau thuế)",
  increase_fee_rate: "Tỷ lệ tăng giá thuê",
  add_payment_term: "Thêm thời hạn thanh toán",
  guide_line: "Hướng dẫn",
  contract: "Hợp đồng",
  financial_performance: "Hoạt động tài chính",
  other_fee: "Các khoản phí khác",
  deposit_method: "Phương thức giải quyết khi đặt cọc",
  deposit_attribute_to_month: "Cấn trừ vào tháng",
  management_fee: "Phí quản lý",
  question: "Câu hỏi đánh giá",
  contract_file: "File hợp đồng",
  contract_file_payment: "File tính tiền thuê dự toán",
  contract_link: "Link với hợp đồng",
  contract_deposit: "Phí đặt cọc",
  contract_store_code: "Mã số cửa hàng",

  revenue_current: "Doanh thu tháng này",
  revenue_last_12: "Doanh thu 12 tháng",
  revenue: "Doanh thu",
  ebitda_current: "Ebitda tháng này",
  ebitda_last_12: "Ebitda 12 tháng",
  ebitda: "Ebitda",
  renew_status: "Trạng thái gia hạn",
  cannot_empty: "Không được bỏ trống",
  empty_contract: (id: number) =>
    `Mặt bằng chưa có hợp đồng tính tiền thuê, vui lòng vào <a class='link-text' href='/sitev2/${id}'>Chi tiết mặt bằng</a> để tạo hợp đồng tính tiền thuê`,

  terminate_reason: "Lý do terminate",
  terminate_date: "Ngày terminate",

  error_no_permissions: "Bạn không có quyền thực hiện hành động này.",
  error_something_went_wrong: "Có lỗi xảy ra. Bạn vui lòng thử lại sau nhé."
};
